import { _, moment } from "../../vendor";

import InboomaBaseFilterableCollection from "./InboomaBaseFilterableCollection";
import Transaction from "../models/Transaction";

export default InboomaBaseFilterableCollection.extend({
  collectionName: "transactions",
  model: Transaction,
  url: "/wallet_transactions",

  _pagination: {
    current_page: 0,
    sort: "payment_date",
    sortDirection: "desc",
    has_next_page: false,
    has_prev_page: false,
    count: 0,
    limit: 100,
  },

  _filterParams: {},

  /**
   * Called via this.prototype.addFilter
   * Only show actual revenues for Tagesabschluss context
   */
  _adjustCollectionUrl() {
    if (
      _.size(this._filterParams) >= 2 &&
      typeof this._filterParams["payment_day"] !== "undefined" &&
      typeof this._filterParams["location_id"] !== "undefined"
    ) {
      this.url = "/wallet_transactions?find=IsPayment";
    } else {
      this.url = "/wallet_transactions?";
    }
  },

  filterLocation(location_id) {
    if (location_id === null || location_id === "") {
      return this.removeFilter("location_id");
    }

    return this.addFilter("location_id", Number(location_id));
  },

  filterPaymentType(payment_type) {
    if (payment_type === null || payment_type === "") {
      return this.removeFilter("payment_type");
    }

    return this.addFilter("payment_type", payment_type);
  },

  filterBeginGte(date) {
    const day = moment(date);
    return this.addFilter("begin_gte", day.format("YYYY-MM-DD"));
  },

  filterEndLte(date) {
    const day = moment(date);
    return this.addFilter("end_lte", day.format("YYYY-MM-DD") + " 23:59:59");
  },

  filterPaymentDay(date) {
    const day = moment(date);
    return this.addFilter("payment_day", day.format("YYYY-MM-DD"));
  },
});
